import { useSelector } from 'react-redux';
import { generatePath, useLocation } from 'react-router';
import { Page } from 'src/creativeHub/models/page';
import { hubRoutes } from 'src/general/urls';
import { INode, Tag } from '../../../general/model';
import { getPage } from '../app/selectors';
import { CHNode, NodePathParams } from '../../../general/node';

export type SearchShape = {
  inProgress: boolean;
  text: string;
  tags: Tag[];
};
export const initialState: SearchShape = {
  inProgress: false,
  text: '',
  tags: [],
};

export type SearchParams = {
  scope: number | null | 'trash';
  query: string;
  tags: number[];
  global: boolean;
  /**
   * AI-режим: семантический поиск по разметке Plot Recognition вместо поиска по имени
   * (MYUA-16771, бэкенд MYUA-16493 — параметр `search_type=semantic`).
   */
  ai: boolean;
};

export function usePageSearchParams():
  | (SearchParams & {
      _url: string;
      _urlWithFile: (f: number) => string;
    })
  | null {
  const page = useSelector(getPage);

  const sp = new URLSearchParams(useLocation().search);
  if (page !== Page.SEARCH) return null;
  const _scope = sp.get('scope');
  //prettier-ignore
  const scope = _scope !== null
      ? _scope === 'trash'
        ? _scope
        : parseInt(_scope)
      : null;
  const query = sp.get('q') ?? '';
  const tags = sp.get('tags')?.split(',').map(parseInt) ?? [];
  const global = sp.get('global') !== null;
  const ai = sp.get('ai') !== null;

  return {
    scope,
    query,
    tags,
    global,
    ai,
    _url: createSearchParamsURL(query, global, tags, scope, undefined, ai),
    _urlWithFile: (fileID: number) => createSearchParamsURL(query, global, tags, scope, fileID, ai),
  };
}

export function createSearchParamsURL(
  query: string | null,
  global: boolean,
  tags: number[],
  scope: number | null | 'trash',
  fileID?: number,
  ai?: boolean,
) {
  let path = generatePath(hubRoutes.search);
  if (fileID) {
    path += '/' + fileID;
  }
  const sp = new URLSearchParams();
  if (query) sp.append('q', query);
  if (scope && !global) {
    sp.append('scope', scope.toString());
  }
  if (global) sp.append('global', '');
  if (tags.length) sp.append('tags', tags.join(','));
  if (ai) sp.append('ai', '');
  return path + '?' + sp.toString();
}

export type SearchAdditionalFields = NodePathParams & { creative_name?: string | null };
export type SearchCHNode = CHNode & SearchAdditionalFields;
export type SearchINode = INode & SearchAdditionalFields;
